import React from "react";
import { LogoImages } from "./Images";
export const Logo = ({
  name,
  ...props
}) => {
  const LogoName = LogoImages[name];
  return LogoName ? React.createElement(LogoName, props) : null;
};